import React from "react";

const AddAppointmentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="add_appointment_icon"
      data-name="add appointment"
      {...props}
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33325 10.0001H7.33325V12.0001H8.66659V10.0001H10.6666V8.66675H8.66659V6.66675H7.33325V8.66675H5.33325V10.0001Z"
        fill={props.fill || "#3A8AB9"}
      />
      <path
        d="M12.6667 2.66659H11.3333V1.33325H10V2.66659H6V1.33325H4.66667V2.66659H3.33333C2.598 2.66659 2 3.26459 2 3.99992V13.3333C2 14.0686 2.598 14.6666 3.33333 14.6666H12.6667C13.402 14.6666 14 14.0686 14 13.3333V3.99992C14 3.26459 13.402 2.66659 12.6667 2.66659ZM12.668 13.3333H3.33333V5.33325H12.6667L12.668 13.3333Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default AddAppointmentIcon;
